const initialPageSize = 10;
const initialPage = 1;


const initialPagination = {
    pageSize: initialPageSize,
    currentPage: initialPage,
};


const initialFilters = {
    searchFilters: {},
    pagination: initialPagination,
    refreshIndex: 0,
};


export const initialState = {
    items: [],
    totalCount: 0,
    filters: initialFilters,
    isLoading: false,
    itemSelected: null,
    pagination: initialPagination,
    indexVisibility: 0,
    refreshIndex: 0,
};


export const reducer = (state, action) => {
    switch (action.type) {
        case "set_loading":
            return { ...state, isLoading: action.payload };
        case "set_index_visibility":
            return { ...state, indexVisibility: action.payload };
        case "set_items":
            return { ...state, items: action.payload.items, totalCount: action.payload.total };
        case "set_search_filters":
            return { ...state, filters: { ...state.filters, searchFilters: action.payload } };
        case "set_table_pagination":
            return { ...state, filters: { ...state.filters, pagination: action.payload } };
        case "open_consult_view":
            return { ...state, itemSelected: action.payload.item, indexVisibility: action.payload.indexVisibility };
        case "refresh_list":
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        default:
            return state;
    }
};